export default __webpack_public_path__ + "static/media/reading_color.b2c855ccfcb7566718717a6a51cde916.svg";